export default "__VITE_ASSET__BiNXnuJn__"